import { Typography } from '@/src/ct-design/lib'
import { Container } from '@/src/ct-design/lib'
import styles from './menuItem.module.css'

interface MenuItemProps {
    label: string
    onClick?: () => void
    icon?: React.ReactNode
    isDisabled?: boolean
    isLink?: boolean
}
const MenuItem = ({
    label,
    onClick,
    icon,
    isDisabled,
    isLink
}: MenuItemProps) => (
    <Container
        className={`flex flex-middle br-4 py-2 px-2 ${isDisabled ? '' : `${styles.hoverBgNeutral300} c-pointer`}`}
        onClick={onClick}
    >
        {!!icon && icon}
        <Typography
            variant='P2'
            color={isDisabled ? 'disabled' : isLink ? 'link' : 'primary'}
            className='mx-2'
        >
            {label}
        </Typography>
    </Container>
)

export default MenuItem
